<template>
  <section>
    <article
      class="ed-article"
      v-html="contentHtml"></article>
  </section>
</template>
<script>
import  edjsParser from 'editorjs-parser'
export default {
  name: 'ArticleHtml',
  props: {
    content: {
      type: [Object],
      default: null
    }
  },
  data() {
    return {
      contentHtml: ''
    }
  },
  watch: {
    content: {
      immediate: true,
      deep: true,
      handler(val) {
        if(val) {
          this.handlerHtml()
        }
      }
    }
  },
  methods: {
    handlerHtml() {
      const parser = new edjsParser(undefined, {
        header: data => {
          return `<h${data.level} class="ed-header ed-header-h${data.level}">${data.text}</h${data.level}>`
        },
        paragraph: data => {
          return `<p class="ed-text">${data.text}</p>`
        },
        image: data => {
          return `
                <div class="ed-image">
                  <img src="${data.file.url}" alt="${data.caption}" />
                  ${data.caption? ('<p>' + data.caption + '</p>'): ''}
                </div>
              `
        },
        list: data => {
          const isOrdered = data.style == 'ordered'
          let list = ''
          data.items.some((item, index) => {
            list = `${list}<li>${item}</li>`
          })
          if(isOrdered) {
            return `<ol class="ed-list">${list}</ol>`
          }
          else {
            return `<ul class="ed-list">${list}</ul>`
          }
        },
        table: data => {
          const isWithHeadings = data.withHeadings

          let content = ''
          data.content.some((item, index) => {
            const isHeading = index == 0 && isWithHeadings
            let trStr = ''
            item.some(td => {
              if(isHeading) {
                trStr = `${trStr}<th>${td}</th>`
              }
              else {
                trStr = `${trStr}<td>${td}</td>`
              }
            })
            content = `${content}<tr ${isHeading? 'class="is-headings"': ''}>${trStr}</tr>`
          })
          return `<table class="ed-table ${isWithHeadings? 'is-with-headings': ''}" border="0" cellpadding="0" cellspacing="0">${content}</table>`
        },
        delimiter: data => {
          return '<div class="ed-delimiter"></div>'
        },
        warning: data => {
          return `
                <div class="ed-warning">
                  <div class="ed-warning-left">
                    <span class="ed-warning-title">${data.title}</span>
                    <div class="ed-warning-icon"></div>
                  </div>
                  <p class="ed-warning-message">${data.message}</p>
                </div>
              `
        },
        quote: data => {
          const isCenter = data.alignment == 'center'
          return `
                <div class="ed-quote ${isCenter? 'center': ''}">
                  <div class="ed-quote-text">${data.text}</div>
                  <div class="ed-quote-caption">${data.caption}</div>
                </div>
              `
        },
        embed: data => {
          return `<iframe class="ed-embed" src="${data.embed}">${data.caption}</iframe>`
        }
      })
      this.contentHtml = parser.parse(this.content)
    }
  }
}
</script>
<style lang="scss">
$yellow: #FFE000;
$blue: #3485F6;
.ed-article {
  position: relative;
  .ed-text, p {
    padding-bottom: 30px;
    font-weight: normal;
    font-size: 18px;
    line-height: 24px;
    mark {
      background: $yellow;
    }
    a {
      color: $blue;
      text-decoration: underline;
    }
    i {
      font-weight: 500;
    }
    b {
      font-weight: 500;
    }
  }
  .ed-image {
    margin-bottom: 30px;
    img {
      display: block;
      width: 100%;
    }
    p {
      padding-top: 10px;
      font-size: 16px;
      line-height: 21px;
      color: #99AAC1;
    }
  }
  img {
    display: block;
    width: 100%;
    max-width: 100%;
  }
   h1, h2, h3, h4, h5, h6 {
    padding-bottom: 30px;
    font-weight: bold;
  }
  h1 {
    font-size: 36px;
    line-height: 48px;
  }
  h2 {
    font-size: 28px;
    line-height: 37px;
  }
  h3 {
    font-size: 24px;
    line-height: 32px;
  }
  h4 {
    font-size: 22px;
    line-height: 29px;
  }
  h5 {
    font-size: 18px;
    line-height: 24px;
  }
  h6 {
    padding-bottom: 20px;
    font-size: 16px;
    line-height: 21px;
  }
  ol {
    list-style: decimal;
  }
  ul {
    list-style: disc;
  }
  ol, ul {
    // &.ed-list {
      margin-bottom: 30px;
      padding-left: 20px;
      font-size: 18px;
      line-height: 24px;
      li {
        padding-top: 16px;
        padding-left: 10px;
        &:first-child {
          padding-top: 0;
        }
      }
    // }
  }
  .ed-delimiter {
    margin-bottom: 30px;
    height: 1px;
    background: #CCD4E0;
  }
  .ed-warning {
    display: flex;
    align-items: center;
    margin-bottom: 30px;
    .ed-warning-left {
      .ed-warning-title {
        display: block;
        text-align: center;
        font-weight: 500;
        font-size: 14px;
        line-height: 19px;
      }
      img {
        display: block;
        margin-top: 5px;
        width: 18px;
      }
      .ed-warning-icon {
        margin: 5px auto 0;
        height: 17.81px;
        width: 32.84px;
        background: url('~@/assets/images/icon/blog-hand-icon.png');
        background-repeat: no-repeat;
        background-size: 100% 100%;
      }
    }
    .ed-warning-message {
      flex: 1;
      padding-left: 30px;
      font-weight: normal;
      font-size: 16px;
      line-height: 21px;
    }
  }
  .ed-quote {
    margin-bottom: 30px;
    padding: 20px;
    background: #DEECFF;
    border-radius: 16px;
    font-size: 16px;
    line-height: 21px;
    &.center {
      text-align: center;
    }
    .ed-quote-text {
      padding-bottom: 10px;
      font-weight: 500;
    }
  }
  // .ed-header {
  //   padding-bottom: 30px;
  //   font-weight: bold;
  //   &.ed-header-h1 {
  //     font-size: 36px;
  //     line-height: 48px;
  //   }
  //   &.ed-header-h2 {
  //     font-size: 28px;
  //     line-height: 37px;
  //   }
  //   &.ed-header-h3 {
  //     font-size: 24px;
  //     line-height: 32px;
  //   }
  //   &.ed-header-h4 {
  //     font-size: 22px;
  //     line-height: 29px;
  //   }
  //   &.ed-header-h5 {
  //     font-size: 18px;
  //     line-height: 24px;
  //   }
  //   &.ed-header-h6 {
  //     padding-bottom: 20px;
  //     font-size: 16px;
  //     line-height: 21px;
  //   }
  // }

  table:not(.ed-table) {
    margin-bottom: 30px;
    width: 100%;
  }

  .ed-table {
    margin-bottom: 30px;
    width: 100%;
    // &.is-with-headings {

    // }
    tr {
      display: flex;
      padding: 16px 0;
      width: 100%;
      font-size: 18px;
      line-height: 24px;
      border-bottom: 1px solid rgba(0, 0, 0, 0.1);
      &:nth-child(2n+1) {
        background: #F3F7FC;
      }
      &.is-headings {
        background: #345582;
        color: white;
      }
      td, th {
        flex: 1;
        text-align: center;
      }
      th {
        font-weight: bold;
        font-size: 16px;
        line-height: 21px;
      }
    }
  }
  .ed-embed, iframe {
    margin-bottom: 30px;
    width: 100%;
    height: 410px;
  }
  // @media screen and (max-width: 769px) {
  //   .ed-embed {
  //     height: 410px;
  //   }
  // }
}
</style>